import React, {Component} from 'react';
import PropTypes from 'prop-types';

import LayoutState from './model/LayoutState';
import Store from './utils/store';

class LayoutProvider extends Component {

  constructor(props) {
    super(props);
    this.store = new Store({
      layoutState: props.layoutState,
      components: props.components,
      addons: props.addons,
      readOnly: props.readOnly
    });
  }

  getChildContext() {
    return {
      store: this.store,
    };
  }

  componentWillReceiveProps(nextProps) {
    const watched = ['components', 'addons', 'readOnly'];
    if (nextProps.layoutState !== this.props.layoutState) {
      this.store.update('layoutState', nextProps.layoutState);
    }
    watched.forEach(key => {
      if (nextProps[key] !== this.props[key]) this.store.update(key, nextProps[key]);
    });
  }

  render() {
    return React.Children.only(this.props.children);
  }

}

LayoutProvider.childContextTypes = {
  store: PropTypes.instanceOf(Store)
};

LayoutProvider.propTypes = {
  layoutState: PropTypes.instanceOf(LayoutState).isRequired,
  components: PropTypes.object.isRequired,
  addons: PropTypes.array,
  readOnly: PropTypes.bool
};

LayoutProvider.defaultProps = {
  addons: []
}

export default LayoutProvider;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/LayoutProvider.js